export default {
    zh: {
        title: '品评报告',
        serialNo: '单据编号',
        name: '产品',
        rater: '评估人',
        rateType: '评估类型',
        rateDate: '评估日期',
        to: '至',
        status: '单据状态',
        sampleSource: 'Sample Source',
        export: '导出',
        batchNo: '批次号',
        attachments: '附件列表',
        addPlant: "添加工厂",
        invalidReason: "禁用原因",
        pleaseMaintainTemplateFirst: "请先维护模板数据!",
        pleaseEnterTheReason: "请输入原因",
        reasonTooLong: "不能超过300字!",
        batchNoCannotBeEmpty: "批次号不能为空!",
        rateTypeCannotBeEmpty: "评估类型不能为空!",
        userNameCannotBeEmpty: "人员（中文）不能为空!",
        plantCannotBeEmpty: "请选择工厂!",
        plantCannotBeSame: "工厂不能相同!",
        batchNoCannotBeSame: "批次号不能相同!",
        scoreRangeErr: "评分需要在{start}-{end}之间",
        overallAppearanceScore: "Overall Appearance Score",
        overallTextureScore: "Overall Texture Score",
        overallFlavorScore: "Overall Flavor Score",
        productQualityScore: "Product Quality Score",
        plantCannotEmpty: '工厂不能为空',
        ReasonCannotEmpty: '原因不能为空',
        addNewSensoryReport: '新增品评报告',
        FactorySelector: '工厂选择器',

    },
    en: {
        reasonTooLong: "No more than 300 words!",
        title: 'Sensory Report',
        serialNo: 'report No.',
        name: 'Product',
        rater: 'Rater',
        rateType: 'Rate Type',
        rateDate: 'Rate Date',
        to: 'To',
        status: 'Report Status',
        sampleSource: 'Sample Source',
        export: 'Export',
        batchNo: 'Batch No.',
        attachments: 'Attachments',
        addPlant: "Add Plant",
        invalidReason: "Invalid Reason",
        pleaseEnterTheReason: "Please enter the reason",
        batchNoCannotBeEmpty: "Batch no. cannot be empty!",
        batchNoCannotBeSame: "Batch no. cannot be same!",
        plantCannotBeEmpty: "Pickup a plant please!",
        plantCannotBeSame: "Plant cannot be same!",
        userNameCannotBeEmpty: "User name cannot be empty!",
        scoreRangeErr: "The Score should between {start} and {end}",
        pleaseMaintainTemplateFirst: "Please maintain template first!",
        overallAppearanceScore: "Overall Appearance Score",
        overallTextureScore: "Overall Texture Score",
        overallFlavorScore: "Overall Flavor Score",
        productQualityScore: "Product Quality Score",
        plantCannotEmpty: 'Plant cannot be empty',
        ReasonCannotEmpty: 'Reason cannot be empty',
        addNewSensoryReport: 'New evaluation report',
        FactorySelector: 'Factory selector',
    }
}